import { Component } from 'react'
import PropTypes from 'prop-types'
import CheckBox from '../forms/CheckBox'
import Label from '../forms/label'
import SpamHamSubmitter from './spam_ham_submitter'
import SpamReporter from './spam_reporter'
import UserDeleter from '../UserDeleter'

export default class SpammableReviewActions extends Component {
  static propTypes = {
    spammableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    spammableType: PropTypes.string.isRequired,
    training: PropTypes.bool,
    className: PropTypes.string,
  }

  static defaultProps = {
    training: false,
    className: 'spammable-actions',
  }

  constructor(props) {
    super(props)
    this.state = {
      training: props.training,
    }
  }

  handleCheckBoxChange = data => {
    const { checked } = data
    this.setState({
      training: checked,
    })
  }

  getUserDeleterContent() {
    const { spammableType, spammableId } = this.props
    if (spammableType !== 'User') {
      return null
    }
    return <UserDeleter userId={spammableId} className="btn spammable-actions__action" />
  }

  render() {
    const { training } = this.state
    const { spammableId, spammableType, className } = this.props
    const userDeleter = this.getUserDeleterContent()
    return (
      <div className={className}>
        <ul className="unstyled-list">
          <li className="spammable-actions__item">
            <Label className="spammable-actions__action">
              <CheckBox checked={training} onChange={this.handleCheckBoxChange} /> Add to training corpus
            </Label>
          </li>
          <li className="spammable-actions__item">
            <SpamHamSubmitter
              spammableId={spammableId}
              spammableType={spammableType}
              spamOrHam="ham"
              training={training}
              label="Mark ham"
              className="btn spammable-actions__action"
            />
          </li>
          <li className="spammable-actions__item">
            <SpamHamSubmitter
              spammableId={spammableId}
              spammableType={spammableType}
              spamOrHam="spam"
              training={training}
              label="Mark spam"
              className="btn spammable-actions__action"
            />
          </li>
          <li className="spammable-actions__item">
            <SpamReporter
              resourceId={spammableId}
              resourceName={spammableType}
              className="btn spammable-actions__action"
            />
          </li>
          <li className="spammable-actions__item">{userDeleter}</li>
        </ul>
      </div>
    )
  }
}
